/*
 * @Descripttion:配置项
 * @Author:
 * @Date: 2020-08-05 16:23:05
 * @FilePath: \dzCloud\src\common\config.js
 */
export default {
    uidConfig: function () {
        if (JSON.parse(localStorage.getItem('userInfo'))) {
            return JSON.parse(localStorage.getItem('userInfo')).uid
                ? JSON.parse(localStorage.getItem('userInfo')).uid + 'config'
                : '';
        }
    },
    imgUrl:
        process.env.NODE_ENV === 'development'
            ? 'https://test-oss.fjdaze.com/'
            : location.host.indexOf('127.0.0.1') !== -1 ||
              location.host.indexOf('192.168.0') !== -1 ||
              (location.host.indexOf('test-douyin.dazeyun.com') > -1
                  ? 'https://test-oss.fjdaze.com/'
                  : 'https://oss.fjdaze.com/'),
};
